var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppiumLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4565 3.95738C26.6553 -0.18717 16.032 -2.24034 8.07104 3.71001C0.602488 8.7166 0.233154 17.8674 0.233154 17.8674C1.50523 22.874 6.55268 27.6752 16.2781 25.3361C15.1292 18.6061 17.3811 1.57746 31.4565 3.95754V3.95738Z",
    fill: "#00ACD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4553 20.2343C21.2015 24.5944 5.20963 31.2476 0.233144 17.8678C-0.955648 24.0981 2.34324 34.4677 11.4768 38.387C19.5469 42.3517 27.957 37.76 27.957 37.76C31.6566 34.1551 33.3438 27.4873 26.4553 20.2343Z",
    fill: "#C8E9EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9661 14.1189C23.3689 16.4888 37.0559 26.7601 27.957 37.76C33.947 35.6742 40.971 27.6938 39.7984 17.8244C39.197 8.85308 31.4566 3.9577 31.4566 3.9577C26.485 2.55616 19.8031 4.52683 16.9661 14.1189",
    fill: "#662D91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppiumLogo);
export default __webpack_public_path__ + "static/media/appium-logo.dbac56d705a8be9af33f5278f97528d1.svg";
export { ForwardRef as ReactComponent };